import React, {useState } from 'react';
import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import {
    Container,
    Row,
    Col
} from 'reactstrap';
import Link from "next/link"
import styles from './styles.module.scss';

export default function MultiColumnsInsight({
    global,
    pathPrefix,
    customClass = "",
    left_column_content,
    center_column_content,
    right_column_content,
    left_column_button_title_1,
    left_column_button_link_1,
    left_column_button_title_2,
    left_column_button_link_2,
    center_formId,
    right_formId,
    center_column_successPageUrl,
    right_column_successPageUrl,
})  {
    const handleOnSubmitDone = (response) => {
        if (response.data.pdfUrl) {
            const a = document.createElement('a');
            a.href = '/pdf/' + response.data.pdfUrl;
            a.download = response.data.pdfUrl;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } 
   };

    return (
        <section className={`${styles.root} ${customClass}`} >
            <Container>
                <hr></hr>
                <Row className="mt-5">
                    <Col md={4} className="mb-4 d-flex align-items-center flex-wrap">
                        <div>
                            {left_column_content ?
                                <div>
                                    <SourceFlowText global={global} path={`${pathPrefix}.left_column_content`} type="html">
                                        {left_column_content}
                                    </SourceFlowText>
                                </div>
                                : null}
                            {left_column_button_link_1 ?
                                <div className="mt-4 w-100">
                                    <Link href={`${left_column_button_link_1}`}>
                                        <a className="primaryBtn no-arrow">
                                            {left_column_button_title_1}
                                        </a>
                                    </Link>
                                    {left_column_button_link_2 ?
                                        <Link href={`${left_column_button_link_2}`}>
                                            <a className="tertiaryBtn no-arrow m-0">
                                                {left_column_button_title_2}
                                            </a>
                                        </Link> : null}
                                </div> : null}
                        </div>
                    </Col>
                    <Col md={4} className="mb-4 center-form">
                        {center_column_content ?
                            <div className="rounded-4 primary-bg p-4 h-100">
                                <SourceFlowText global={global} path={`${pathPrefix}.center_column_content`} type="html">
                                    {center_column_content}
                                </SourceFlowText>
                                {center_formId ?
                                    <div className="mt-4">
                                        <SourceFlowForm
                                            formId={center_formId}
                                            onSubmitDone={() => (window.location.href = center_column_successPageUrl)}
                                        /></div> : ""}
                            </div>
                            : null}
                    </Col>
                    <Col md={4} className="mb-4 right-form">
                        {right_column_content ?
                            <div className="rounded-4 tertiary-bg p-4">
                                <SourceFlowText global={global} path={`${pathPrefix}.right_column_content`} type="html">
                                    {right_column_content}
                                </SourceFlowText>
                                {right_formId ?                           
                                    <div className="mt-4">
                                        <SourceFlowForm
                                            formId={right_formId}
                                            onSubmitDone={() => (window.location.href = right_column_successPageUrl)}
                                        />
                                    </div> : ""}
                            </div>
                            : null}
                    </Col>
                </Row>
            </Container>
        </section>
    )
}